import React from 'react'
import analytics from '@/shared-utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import buildGA4ObjectForPostBookingXSell, {
  BuildGA4ObjectForPostBookingXSellInput
} from '@/shared-utils/ga4/post-booking-xsell'
import CarProduct from './CarProduct'
import HotelProduct from './HotelProduct'
import { Listing, CarListing, ProductType } from './types'

export function fireEventForViewMoreDeals(
  props: BuildGA4ObjectForPostBookingXSellInput
) {
  analytics.fireEvent({
    action: 'Feature Box CTA',
    category: ANALYTICS_CATEGORY_HOME,
    label: 'Cross Sell View More Deals'
  })
  analytics.fireGA4Event(buildGA4ObjectForPostBookingXSell(props))
}

function isCarListing(listing: Listing): listing is CarListing {
  return (listing as CarListing).carExample !== undefined
}

function renderXSellProduct({
  listing,
  offerToken,
  offerId,
  parentProductId,
  destination
}: {
  listing: Listing
  offerToken: string
  offerId: string
  parentProductId: ProductType
  destination: string
}) {
  if (isCarListing(listing)) {
    return (
      <CarProduct
        key={listing.id}
        listing={listing}
        offerId={offerId}
        parentProductId={parentProductId}
        destination={destination}
      />
    )
  }
  return (
    <HotelProduct
      key={listing.hotelId}
      listing={listing}
      offerToken={offerToken}
      offerId={offerId}
      parentProductId={parentProductId}
      destination={destination}
    />
  )
}

export function renderXSellProducts({
  listings,
  offerToken,
  numProducts = 2,
  offerId,
  parentProductId,
  destination
}: {
  listings: Listing[]
  offerToken: string
  numProducts: number
  offerId: string
  parentProductId: ProductType
  destination: string
}) {
  return listings.slice(0, numProducts).map(listing =>
    renderXSellProduct({
      listing,
      offerToken,
      offerId,
      parentProductId,
      destination
    })
  )
}
